/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    arrayOf, func, object, shape, string,
} from 'prop-types';

import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import MarkdownText from '../Partials/MarkdownText';
import InputField from '../Partials/InputField';
import OfferButton from '../Partials/OfferButton';
import noop from '../../../../../../helpers/noop';
import { setOfferInboxData } from '../../../../../../../state/ducks/App/App-Actions';

const useStructureStyles = makeStyles((theme) => ({
    root: (props) => ({
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    }),
    imageWrap: (props) => ({
        width: '430px',
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    }),

    contentWrap: (props) => ({
        padding: '24px',
        width: '430px',
        textAlign: 'center',
        '& > div': {
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            height: '100%',
        },
        '& .markdown-body': {
            padding: 0,
        },
        '& form': {
            margin: '0',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            padding: '36px 24px 32px',
        },
    }),
    inlineBlock: {
        display: 'inline-block',
    },
}), { name: 'PopupStructure' });

const PopupStructure = ({ structure, offer, trackClickThrough }) => {
    const classes = useStructureStyles();
    const dispatch = useDispatch();

    const imageItem = structure.find((item) => item?.image);
    const contentItems = structure.filter((item) => !item?.image);

    const handleClick = (buttonData) => {
        if (buttonData?.cta_button?.launch_modal) {
            dispatch(setOfferInboxData({
                usePopup: false,
                showDefaultOffers: true,
            }));
        }
        trackClickThrough();
    };

    const renderStructureItem = (item, index) => {
        const type = Object.keys(item || {})[0];
        const data = item?.[type];

        switch (type) {
            case 'text':
                return <MarkdownText key={`${type}-${index}`} data={data} />;

            case 'input_field':
                return (
                    <InputField
                        key={`${type}-${index}`}
                        data={data}
                        offer={offer}
                        formId={offer?.content?.input_form_id}
                    />
                );

            case 'button':
                return (
                    <OfferButton
                        key={`${type}-${index}`}
                        buttonData={data}
                        offer={offer}
                        className={data?.cta_button?.full_width ? '' : classes.inlineBlock}
                        trackClickThrough={() => handleClick(data)}
                    />
                );

            default:
                return null;
        }
    };

    return (
        <Box className={classes.root}>
            {imageItem?.image?.file?.url ? (
                <Box className={classes.imageWrap}>
                    <img
                        src={imageItem?.image?.file?.url}
                        alt="Offer Image"
                        style={{ maxWidth: '100%' }}
                    />
                </Box>
            ) : null}

            <Box className={classes.contentWrap}>
                <div>
                    {contentItems.map(renderStructureItem)}
                </div>
            </Box>
        </Box>
    );
};

PopupStructure.propTypes = {
    structure: arrayOf(
        shape({
            text: object,
            image: shape({
                file: shape({
                    url: string,
                }),
            }),
            input_field: object,
            button: object,
        }),
    ),
    offer: shape({
        content: object,
        value: object,
    }),
    trackClickThrough: func,
};

PopupStructure.defaultProps = {
    structure: [],
    offer: {},
    trackClickThrough: noop,
};

export default PopupStructure;
